import { Link, InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

const PBS_NUMBER_ANNOTATION = 'itkom.pbs.ch/pbs-number';

export function MiDataProfileCard() {
    const { entity } = useEntity();
    const pbsNumber = entity.metadata.annotations?.[PBS_NUMBER_ANNOTATION];

    if (!pbsNumber) {
        return null;
    }

    const midataUrl = `https://db.scout.ch/de/people/${pbsNumber}`;

    return (
        <InfoCard title="MiData">
            <Link to={midataUrl} externalLinkIcon>
                Profil in MiData öffnen (PBS-Nr. {pbsNumber})
            </Link>
        </InfoCard>
    );
}
